// extracted by mini-css-extract-plugin
export default {"loading":"LogoLoading-module--loading--d6283","stalled":"LogoLoading-module--stalled--57d06"};